import React, { useState } from "react";
import { isDevelopment } from "common/utils/tools";
import useURLSearchParams from "../../../../../../hooks/useURLSearchParams";
import TabGroup from "../../../../../Common/TabGroup";
import { ColumnWrapper } from "../__styles__/SubmissionsBuilder";
import {
  SUBMISSIONS_BUILDER_MODE,
  useSubmissionsBuilderMode,
} from "../SubmissionsBuilderContext";
import { TabGroupWrapper } from "./__styles__/SidebarColumn";
import { FieldsTab } from "./FieldsTab/FieldsTab";
import { FormSettingsTab } from "./FormSettingsTab";

const JSON_PREVIEW_ENABLED_KEY = "jsonPreviewEnabled";
const JSON_PREVIEW_ENABLED_VALUE = "1";

type TabId = "fields" | "settings" | "jsonPreview";

type Tab = { label: string; value: TabId };

const DEFAULT_TABS: Array<Tab> = [
  { label: "Fields", value: "fields" },
  { label: "Settings", value: "settings" },
];

const tabNameToTabBodyMap: Record<TabId, React.ComponentType> = {
  fields: FieldsTab,
  settings: FormSettingsTab,
  jsonPreview: () => <div>JSON Preview</div>,
};

export function SidebarColumn() {
  const { hasParamWithValue } = useURLSearchParams();
  const [activeTab, setActiveTab] = useState<TabId>("fields");
  const [mode] = useSubmissionsBuilderMode();

  const isJsonPreviewEnabled =
    hasParamWithValue(JSON_PREVIEW_ENABLED_KEY, JSON_PREVIEW_ENABLED_VALUE) ||
    isDevelopment();

  const tabs: Array<Tab> = [];

  if (mode === SUBMISSIONS_BUILDER_MODE.BUILD) {
    tabs.push(...DEFAULT_TABS);

    if (isJsonPreviewEnabled) {
      tabs.push({ label: "JSON Preview", value: "jsonPreview" });
    }
  }

  const resolvedActiveTab =
    mode === SUBMISSIONS_BUILDER_MODE.VERSION_HISTORY ? "settings" : activeTab;
  const TabBody = tabNameToTabBodyMap[resolvedActiveTab];

  return (
    <ColumnWrapper role="complementary" left>
      <div>
        <TabGroupWrapper>
          <TabGroup<TabId>
            currentTab={activeTab}
            setTab={setActiveTab}
            tabs={tabs}
          />
        </TabGroupWrapper>
        <TabBody />
      </div>
    </ColumnWrapper>
  );
}
